const initialState = {
  resultsProductsList: [],
  resultsProduct: {},
  loading: false,
  error: null,
  productCreateResponse: null,
  productUpdateResponse: null,
  productDuplicateResponse: null,
  resultsCabanasList: [],
  productFiles: [],
  productFilesProductUuid: null,
  productFileDeleteResponse: null,
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "DUPLICATE_PRODUCT":
      return { ...state, loading: true, error: null };
    case "PRODUCTS_RESPONSE_DUPLICATE":
      return {
        ...state,
        loading: false,
        productDuplicateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null
      };
    case "LIST_PRODUCT_RESPONSE_GET":
      newState.resultsProductsList = action.value;
      break;
    case "PRODUCT_RESPONSE_GET":
      newState.resultsProduct = action.value;
    case "CREATE_PRODUCTS":
      return { ...state, loading: true, error: null };
    case "PRODUCTS_RESPONSE_CREATE":
      return {
        ...state,
        loading: false,
        productCreateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null
      };
    case "UPDATE_PRODUCT":
      return { ...state, loading: true, error: null };
    case "PRODUCTS_RESPONSE_UPDATE":
      return {
        ...state,
        loading: false,
        productUpdateResponse: action.value,
        error: action.value.responseStatus === "error" ? action.value : null
      };
    case "LIST_CABANAS_RESPONSE_GET":
      newState.resultsCabanasList = action.value;
      break;
    case "GET_PRODUCT_FILES_RESPONSE":
      if (Array.isArray(action.value)) {
        newState.productFiles = action.value;
        newState.productFilesProductUuid = action.productUuid || null;
      } else if (Array.isArray(action.value?.records)) {
        newState.productFiles = action.value.records;
        newState.productFilesProductUuid = action.productUuid || null;
      } else {
        newState.productFiles = state.productFiles || [];
        newState.productFilesProductUuid = state.productFilesProductUuid;
      }
      break;
    case "DELETE_PRODUCT_FILE_RESPONSE":
      newState.productFileDeleteResponse = {
        ...action.value,
        fileUuid: action.fileUuid,
        productUuid: action.productUuid,
      };
      if (
        action.fileUuid &&
        (action.value?.responseStatus === "success" ||
          action.value?.ok === true ||
          (action.value?.status >= 200 && action.value?.status < 300))
      ) {
        newState.productFiles = (state.productFiles || []).filter(
          (file) => file.uuid !== action.fileUuid,
        );
        newState.productFilesProductUuid =
          action.productUuid || state.productFilesProductUuid;
      }
      break;

    case "RESET_PRODUCTS_RESPONSES":
      return {
        ...state,
        resultsProductsList: {},
        resultsProduct: {},
        productCreateResponse: null,
        productUpdateResponse: null,
        productUpdateResponse: null,
        productDuplicateResponse: null,
        productFiles: [],
        productFilesProductUuid: null,
        productFileDeleteResponse: null,
      }
    default:
      break;
  }
  return newState;
}

export default reducer;
